module.exports = __webpack_public_path__ + "media/PAG59-02.3d2f22a9.mp3";